import React from 'react';

const FinalCTA = () => {
  return (
    <section
      id="final-cta"
      className="py-20 text-white relative overflow-hidden"
      style={{
        background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)",
      }}
    >



      {/* === CONTENT === */}
      <div className="container mx-auto px-6 relative z-10 text-center">
        <h2 className="text-4xl lg:text-6xl font-bold mb-6">
          Start Earning Amazon Income Today
        </h2>

        <p className="text-2xl mb-8 opacity-90">
          Join Hector's Affiliate Network & Get Paid Monthly for Every Referral
        </p>

<a 
  href="https://hector.partnerstack.com/" 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block"
>
  <button
    className="px-10 py-5 rounded-xl font-bold text-xl shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 transition-all duration-300 mb-6 w-auto inline-block"
    style={{
      background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)",
    }}
  >
    GET YOUR AFFILIATE LINK IN 5 MINUTES
  </button>
</a>


        <p className="text-lg opacity-90">
          <span className="font-bold">Affiliates are already earning 4 - 5 figures monthly.</span> You can too.
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;
